export const LinkedinRound = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <circle cx='12' cy='12' r='12' fill='#069' fillOpacity='0.1'></circle>
        <path
          fill='#069'
          d='M7 7.716C7 7.321 7.329 7 7.734 7h8.469c.405 0 .734.32.734.716v8.568a.726.726 0 01-.734.716H7.734A.725.725 0 017 16.284V7.716z'
        ></path>
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M10.012 15.371v-4.515h-1.5v4.515h1.5zm-.75-5.132c.523 0 .849-.347.849-.78-.01-.443-.326-.78-.84-.78-.513 0-.848.337-.848.78 0 .433.325.78.83.78h.009zM10.843 15.371h1.5V12.85c0-.135.01-.27.05-.366.108-.27.355-.549.77-.549.543 0 .76.414.76 1.021v2.416h1.501v-2.589c0-1.387-.74-2.032-1.728-2.032-.81 0-1.165.452-1.362.76h.01v-.654h-1.501c.02.423 0 4.515 0 4.515z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
